import React, { PropsWithChildren, createContext, useState } from "react";

import { Percentiles, SupportedPercentiles } from "lib/frontend/benchmarking/types";

type ISelectedPercentileContext = {
  selectedPercentile: SupportedPercentiles;
  setSelectedPercentile: (percentile: SupportedPercentiles) => void;
};

const SelectedPercentileContext = createContext<ISelectedPercentileContext>({
  selectedPercentile: Percentiles.Fifty,
  setSelectedPercentile: () => {},
});

export const SelectedPercentileProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  // @ts-expect-error TS2345
  const [selectedPercentile, setSelectedPercentile] = useState<SupportedPercentiles>("50");

  return (
    <SelectedPercentileContext.Provider value={{ selectedPercentile, setSelectedPercentile }}>
      {children}
    </SelectedPercentileContext.Provider>
  );
};

export const useSelectedPercentile = () => {
  const context = React.useContext(SelectedPercentileContext);

  if (context === undefined) {
    throw new Error("useSelectedPercentile must be used within a SelectedPercentileProvider");
  }
  return context;
};
